function syncCartDiscount() {
  ltLazyLoad(function () {
    fetch(`${Shopify.routes.root}cart.js`).then(response => response.json())
      .then(data => {
        const { discount_codes } = data;

        let codes = [];
        if (discount_codes && discount_codes.length > 0) {
          codes = discount_codes.map(x => x.code);
        }

        const cartDiscountEl = document.querySelector('[data-cart-discount]');
        if (cartDiscountEl) {
          cartDiscountEl.value = codes.join(',');
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
  });
}

syncCartDiscount();

window.addEventListener('pageshow', function (e) {
  syncCartDiscount();
});